export default Object.freeze({
  ALL_COMMENTS: 'ALL_COMMENTS',
  ALL_COMMENTS_POLARIZED: 'COMMENTS_POLARIZED',
  ALL_COMMENTS_NO_POLARIZED: 'COMMENTS_NO_POLARIZED',
})
